import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { C, Btn, Input } from "../components/UI";

export default function MeuPerfil() {
  const navigate = useNavigate();
  const { user, profile, updateProfile, loading } = useApp();
  const [editando, setEditando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  
  // Funcao para obter dados atuais do usuario
  const getDadosAtuais = () => ({
    nome: profile?.nome || user?.user_metadata?.name || "",
    email: user?.email || profile?.email || "",
    telefone: profile?.telefone || "",
    cidade: profile?.cidade || "",
    estado: profile?.estado || "",
    linkedin: profile?.linkedin || "",
    areas_interesse: profile?.areas_interesse || [],
    sobre: ""
  });

  const [dados, setDados] = useState(getDadosAtuais);

  // Atualiza dados quando o profile muda
  useEffect(() => {
    setDados(getDadosAtuais());
  }, [profile, user]);

  const handleChange = (e) => {
    setDados(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleCancelar = () => {
    setDados(getDadosAtuais());
    setEditando(false);
  };

  const handleSave = async () => {
    setSalvando(true);
    
    const { error } = await updateProfile({
      nome: dados.nome,
      telefone: dados.telefone,
      cidade: dados.cidade,
      estado: dados.estado,
      linkedin: dados.linkedin,
    });
    
    setSalvando(false);
    
    if (error) {
      alert("Erro ao salvar perfil. Tente novamente.");
      return;
    }
    
    setEditando(false);
    alert("Perfil atualizado com sucesso!");
  };

  // Redireciona se nao estiver logado
  useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p>Carregando...</p>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  const initials = dados.nome ? dados.nome.split(" ").map(n => n[0]).join("").substring(0, 2).toUpperCase() : "U";

  return (
    <div style={{ minHeight: "100vh", background: C.bg }}>
      {/* Header */}
      <section style={{ background: C.roseMid, padding: "60px 20px 40px", textAlign: "center" }}>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 36, color: "#fff", marginBottom: 8 }}>
          Meu Perfil
        </h1>
        <p style={{ color: "rgba(255,255,255,0.8)", fontSize: 16 }}>
          Gerencie suas informacoes pessoais
        </p>
      </section>

      <section style={{ maxWidth: 800, margin: "0 auto", padding: "40px 20px" }}>
        {/* Card do perfil */}
        <div style={{ 
          background: C.surface, 
          borderRadius: 16, 
          padding: 32, 
          border: `1px solid ${C.border}`,
          marginBottom: 24
        }}>
          {/* Avatar e nome */}
          <div style={{ display: "flex", alignItems: "center", gap: 20, marginBottom: 32 }}>
            <div style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: C.rosePale,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 28,
              fontWeight: 600,
              color: C.roseMid
            }}>
              {initials}
            </div>
            <div>
              <h2 style={{ fontSize: 24, fontWeight: 600, color: C.textMain, marginBottom: 4 }}>
                {dados.nome || "Seu nome"}
              </h2>
              <p style={{ fontSize: 14, color: C.textSec }}>{dados.email}</p>
              {profile?.areas_interesse?.length > 0 && (
                <p style={{ fontSize: 13, color: C.roseMid, marginTop: 4 }}>{profile.areas_interesse.join(", ")}</p>
              )}
            </div>
          </div>

          {/* Formulario */}
          {editando ? (
            <div style={{ display: "grid", gap: 16 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                <Input label="Nome completo" name="nome" value={dados.nome} onChange={handleChange} />
                <Input label="E-mail" name="email" type="email" value={dados.email} onChange={handleChange} disabled />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                <Input label="Telefone" name="telefone" value={dados.telefone} onChange={handleChange} />
                <Input label="LinkedIn" name="linkedin" value={dados.linkedin} onChange={handleChange} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                <Input label="Cidade" name="cidade" value={dados.cidade} onChange={handleChange} />
                <Input label="Estado" name="estado" value={dados.estado} onChange={handleChange} />
              </div>
              <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
                <Btn variant="primary" onClick={handleSave} disabled={salvando}>
                  {salvando ? "Salvando..." : "Salvar alteracoes"}
                </Btn>
                <Btn variant="ghost" onClick={handleCancelar} disabled={salvando}>Cancelar</Btn>
              </div>
            </div>
          ) : (
            <div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginBottom: 24 }}>
                <div>
                  <label style={{ fontSize: 12, color: C.textSec, marginBottom: 4, display: "block" }}>Telefone</label>
                  <p style={{ fontSize: 15, color: C.textMain }}>{dados.telefone || "-"}</p>
                </div>
                <div>
                  <label style={{ fontSize: 12, color: C.textSec, marginBottom: 4, display: "block" }}>LinkedIn</label>
                  <p style={{ fontSize: 15, color: C.textMain }}>{dados.linkedin || "-"}</p>
                </div>
                <div>
                  <label style={{ fontSize: 12, color: C.textSec, marginBottom: 4, display: "block" }}>Cidade</label>
                  <p style={{ fontSize: 15, color: C.textMain }}>
                    {dados.cidade ? `${dados.cidade}${dados.estado ? `, ${dados.estado}` : ""}` : "-"}
                  </p>
                </div>
                {profile?.areas_interesse?.length > 0 && (
                  <div>
                    <label style={{ fontSize: 12, color: C.textSec, marginBottom: 4, display: "block" }}>Areas de interesse</label>
                    <p style={{ fontSize: 15, color: C.textMain }}>{profile.areas_interesse.join(", ")}</p>
                  </div>
                )}
              </div>
              <Btn variant="primary" onClick={() => setEditando(true)}>Editar perfil</Btn>
            </div>
          )}
        </div>

        {/* Cards de acoes rapidas */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16 }}>
          <div 
            onClick={() => navigate("/completar-curriculo")}
            style={{ 
              background: C.surface, 
              borderRadius: 12, 
              padding: 20, 
              border: `1px solid ${C.border}`,
              cursor: "pointer",
              transition: "transform 0.15s, box-shadow 0.15s"
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
          >
            <span style={{ fontSize: 24, marginBottom: 8, display: "block" }}>📄</span>
            <h3 style={{ fontSize: 15, fontWeight: 600, color: C.textMain, marginBottom: 4 }}>Meu Curriculo</h3>
            <p style={{ fontSize: 13, color: C.textSec }}>Atualize suas experiencias</p>
          </div>
          <div 
            onClick={() => navigate("/minhas-avaliacoes")}
            style={{ 
              background: C.surface, 
              borderRadius: 12, 
              padding: 20, 
              border: `1px solid ${C.border}`,
              cursor: "pointer",
              transition: "transform 0.15s, box-shadow 0.15s"
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
          >
            <span style={{ fontSize: 24, marginBottom: 8, display: "block" }}>⭐</span>
            <h3 style={{ fontSize: 15, fontWeight: 600, color: C.textMain, marginBottom: 4 }}>Minhas Avaliacoes</h3>
            <p style={{ fontSize: 13, color: C.textSec }}>Veja suas avaliacoes</p>
          </div>
          <div 
            onClick={() => navigate("/vagas-salvas")}
            style={{ 
              background: C.surface, 
              borderRadius: 12, 
              padding: 20, 
              border: `1px solid ${C.border}`,
              cursor: "pointer",
              transition: "transform 0.15s, box-shadow 0.15s"
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
          >
            <span style={{ fontSize: 24, marginBottom: 8, display: "block" }}>💼</span>
            <h3 style={{ fontSize: 15, fontWeight: 600, color: C.textMain, marginBottom: 4 }}>Vagas Salvas</h3>
            <p style={{ fontSize: 13, color: C.textSec }}>Acesse vagas de interesse</p>
          </div>
        </div>
      </section>
    </div>
  );
}
